export class EmbeddedPlayerMessageHandler {
  static instance(videoPlaylistId, root, rootMargin, iFrame) {
    return new EmbeddedPlayerMessageHandler(videoPlaylistId, root, rootMargin, iFrame);
  }

  constructor(videoPlaylistId, root, rootMargin, iFrame) {
    this.videoPlaylistId = videoPlaylistId;
    this.root = root;
    this.rootMargin = rootMargin;
    this.iFrame = iFrame;
    this.observer = null;
  }

  init() {
    window.addEventListener('message', (event) => {
      if (event.data?.name === `showcase-ready-${this.videoPlaylistId}`) {
        this.bindEvents();
      }

      if (event.data?.name === `showcase-resize-${this.videoPlaylistId}`) {
        this.emit('showcase-resized', { height: event.data.height });
      }
    });
  }

  onVisibilityChange(entries){
    entries.forEach(entry => {
      const isVisible = entry.isIntersecting && entry.intersectionRatio >= 0.5;

      if (!isVisible) {
        this.onHidden();
      }
    });
  }

  bindEvents() {
    this.observer = new IntersectionObserver(this.onVisibilityChange.bind(this), {
      root: this.root,
      rootMargin: this.rootMargin,
      threshold: [0.5],
    });

    this.observer.observe(this.iFrame);
  }

  onHidden() {
    this.iFrame.contentWindow
    .postMessage(`pause-showcase-${this.videoPlaylistId}`, '*');
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  emit(eventName, data) {
    const event = new CustomEvent(eventName, {
      detail: data,
    });

    window.dispatchEvent(event);
  }
}